import { FIELD_ITEMS_ENTITY_TYPE } from "app/main/apps/scheduler/task-board/shared-components/calibration/calibrationConstants";
import _ from 'lodash';


export async function resetCalibrationStatus(payload) {
  const labEquip = payload.labEquipment[0];

  const calibrationData = labEquip.calibration.map((c, idx) => ({
    id: 434 + idx, // starting ID sequence (can be dynamic if needed)
    calibVal1: Number(c.calibVal1), // convert to number
    calibUnits: c.calibUnits,
    ...(c.labChemicalId && { labChemicalId: c.labChemicalId }) // include only if present
  }));

  const lastCalibTime = new Date().toISOString();

  return {
    status: 200,
    data: {
      calibrationRequired: false,
      lastCalibTime,
      calibrationData,
      message: `Test count(0) is less than limit (10) after last calibration time ${lastCalibTime}.`,
      verifyRequired: false,
      labEquipId: labEquip.labEquipId,
      readingsCount: 0,
      duplicateReadingsCount: 0
    }
  };
}


export const updateVerificationItems = (existingItems, newItems) => {
  const mergedItems = [...existingItems];
  newItems.forEach(newItem => {
    const existingIndex = mergedItems.findIndex(item =>
      item.entityType === newItem.entityType && item.itemType === newItem.itemType
    );
    if (existingIndex >= 0) {
      mergedItems[existingIndex] = newItem;
    } else {
      mergedItems.push(newItem);
    }
  });
  return mergedItems;
};


export const buildAssignMap = (items) => {
  return items
    .filter(i => i.itemId != null && i.itemType)
    .reduce((map, i) => {
      map[`${i.entityType}::${i.itemType}`] = i.itemId;
      return map;
    }, {});
};

export const updateAssignedItems = (items, entityType, typeProperty, assignMap) => {
  return items.map(item => {
    const key = `${entityType}::${item[typeProperty]}`;
    if (!(key in assignMap)) return item;
    return { ...item, assigned: item.id === assignMap[key] };
  });
};

export const getUpdatedFieldItems = (fieldItems, items) => {
  const assignMap = buildAssignMap(items);
  return {
    equipment: updateAssignedItems(fieldItems.equipment, FIELD_ITEMS_ENTITY_TYPE.EQUIPMENT, 'equipType', assignMap),
    chemicals: updateAssignedItems(fieldItems.chemicals, FIELD_ITEMS_ENTITY_TYPE.CHEMICAL_LOG, 'chemicalType', assignMap),
    supplies: updateAssignedItems(fieldItems.supplies, FIELD_ITEMS_ENTITY_TYPE.SUPPLY_LOG, 'supplyType', assignMap),
  };
};


export function createIdMap(data = []) {
  const map = {}
  _.forEach(data, item => {
    map[item.id] = item
  })
  return map
}